import { useState, useEffect } from 'react';

export default function PromoBanner() {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosed, setIsClosed] = useState(false);

  useEffect(() => {
    // Check if user has closed the banner
    const bannerClosed = sessionStorage.getItem('promoBannerClosed');
    
    if (!bannerClosed) {
      // Show banner after 500ms with fade-in animation
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 500);

      return () => clearTimeout(timer);
    } else {
      setIsClosed(true);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      setIsClosed(true);
      sessionStorage.setItem('promoBannerClosed', 'true');
    }, 300);
  };

  if (isClosed) return null;

  return (
    <div 
      className={`bg-gradient-to-r from-red-600 to-orange-600 text-white py-3 px-4 relative overflow-hidden transition-all duration-500 mt-20 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-full'
      }`}
      style={{
        backgroundImage: `linear-gradient(to right, rgba(220, 38, 38, 0.95), rgba(234, 88, 12, 0.95)), url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 20 Q 10 15, 20 20 T 40 20 V 40 H 0 Z' fill='%23ffffff' fill-opacity='0.05'/%3E%3C/svg%3E")`,
        backgroundSize: '40px 40px'
      }}
    >
      <div className="container mx-auto flex items-center justify-center relative">
        <div className="flex items-center space-x-3 text-center">
          <i className="ri-fire-fill text-2xl w-6 h-6 flex items-center justify-center animate-pulse"></i>
          <p className="text-sm md:text-base font-semibold">
            <span className="font-bold text-yellow-300">🎉 Year-End Sale!</span> Get <span className="font-bold text-xl">35% OFF</span> on orders over <span className="font-bold">$100</span> - Limited Time Only!
          </p>
          <i className="ri-fire-fill text-2xl w-6 h-6 flex items-center justify-center animate-pulse"></i>
        </div>
        
        <button 
          onClick={handleClose}
          className="absolute right-2 text-white hover:text-gray-200 transition-colors cursor-pointer"
          aria-label="Close banner"
        >
          <i className="ri-close-line text-xl w-5 h-5 flex items-center justify-center"></i>
        </button>
      </div>
    </div>
  );
}
